import { render, staticRenderFns } from "./Vendor.vue?vue&type=template&id=27d3b9e4"
import script from "./Vendor.vue?vue&type=script&lang=js"
export * from "./Vendor.vue?vue&type=script&lang=js"
import style0 from "./Vendor.vue?vue&type=style&index=0&id=27d3b9e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports